import { render, staticRenderFns } from "./PhonePrefixField.vue?vue&type=template&id=7a167ab4&scoped=true&"
import script from "./PhonePrefixField.vue?vue&type=script&lang=js&"
export * from "./PhonePrefixField.vue?vue&type=script&lang=js&"
import style0 from "./PhonePrefixField.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PhonePrefixField.vue?vue&type=style&index=1&id=7a167ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a167ab4",
  null
  
)

export default component.exports